module.exports = __webpack_public_path__ + "img/icon-flash.062da934.svg";